<template>
  <div class="flex items-center justify-center min-h-[calc(100vh-80px)] w-full">
    <div class="flex flex-col items-center gap-4">
      <ProgressSpinner
        strokeWidth="4"
        animationDuration="1s"
        aria-label="Loading"
        class="w-12 h-12"
      />
      <p class="text-[var(--p-anthracite-500)] text-sm m-0">Loading...</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner'
</script>
